var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-content',{staticClass:"ion-padding",attrs:{"id":"app"}},[_c('h1',[_vm._v("Link bearbeiten")]),_c('LinkFields',{attrs:{"modus":"edit","box":_vm.box,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }